import { publish } from '@ltvco/refresh-lib';
import { Grid } from '@ltvco/refresh-lib/theme';
import { NeedAssistanceSidebar } from '@ltvco/refresh-lib/v1';
import { Footer } from '@ltvco/refresh-lib/v2';

import { constants } from 'appConstants';
import { Billing } from 'routes';

import { ChatPageContainerStack } from '..';

import type { FooterProps } from '../ChatBVContainer';

interface AccountPageProps {
  footerProps: FooterProps;
  onCancelConfirmCancelModal: () => void;
  openConfirmCancelModal: () => void;
  onLogout: () => void;
}

export const AccountPage = ({
  footerProps,
  onCancelConfirmCancelModal,
  openConfirmCancelModal,
  onLogout,
}: AccountPageProps) => {
  const {
    footerLinks,
    libVersion,
    hasMobileApps,
    userInReactivationRedesignTest,
  } = footerProps;

  return (
    <ChatPageContainerStack>
      <Grid
        container
        spacing={{ xs: 2, md: 4, lg: 6 }}
        padding={2}
        width="100%"
      >
        <Grid size={{ xs: 12, md: 8, lg: 9 }}>
          <Billing
            onCancelConfirmCancelModal={onCancelConfirmCancelModal}
            optoutCtaCards={true}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4, lg: 3 }} maxWidth={{ md: '275px' }}>
          <NeedAssistanceSidebar
            logout={onLogout}
            supportImgUrl={constants.images.img24hr}
            contactUsHandler={() => {
              publish('openContactModal');
            }}
            openConfirmCancelModal={openConfirmCancelModal}
          />
        </Grid>
      </Grid>
      {/* TODO: Replace with custom footer for ChatBV feature */}
      <Footer
        footerLinks={footerLinks}
        libVersion={libVersion}
        hasMobileApps={hasMobileApps}
        openConfirmCancelModal={openConfirmCancelModal}
        userInReactivationRedesignTest={userInReactivationRedesignTest}
      />
    </ChatPageContainerStack>
  );
};
